<label class="embed-code-label" for="embed-code">
  {{ title }}
</label>
<pre disabled id="embed-code" class="custom-text-area embed-code-area">
  {{ value }}
</pre>
<button class="custom-button grey-button mt-3" (click)="copyToClipboard()">
  {{ ctaText }}
</button>
